import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import style from "./DonationImpactItemAnimalWelfare.module.scss";
import { thousandize, thousandizeString } from "../../../../../util/formatting";
import useSWR from "swr";
import { ImpactEvaluation } from "../../../../../models";
import AnimateHeight from "react-animate-height";
import { Links } from "../../../../main/blocks/Links/Links";
import { PortableText } from "@portabletext/react";
export type ImpactItemConfiguration = {
  output_subheading_format_string: string;
  missing_evaluation_header: string;
  missing_impact_evaluation_text: any[];
  about_org_link_title_format_string: string;
  about_org_link_url_format_string: string;
  currency: string;
  locale: string;
};
export const DonationImpactItemAnimalWelfare: React.FC<{
  orgAbriv: string;
  sumToOrg: number;
  donationTimestamp: Date;
  precision: number;
  signalRequiredPrecision: (precision: number) => void;
  configuration: ImpactItemConfiguration;
}> = t0 => {
  const $ = _c(33);
  const {
    orgAbriv,
    sumToOrg,
    configuration
  } = t0;
  const [showDetails, setShowDetails] = useState(false);
  let t1;
  if ($[0] !== sumToOrg) {
    t1 = thousandize(Math.round(sumToOrg));
    $[0] = sumToOrg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <td><span className={style.impactOutput} data-cy="donation-impact-list-item-output">{t1}</span></td>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== configuration.output_subheading_format_string || $[5] !== orgAbriv || $[6] !== sumToOrg) {
    t3 = configuration.output_subheading_format_string.replace("{{sum}}", thousandize(Math.round(sumToOrg))).replace("{{org}}", orgAbriv);
    $[4] = configuration.output_subheading_format_string;
    $[5] = orgAbriv;
    $[6] = sumToOrg;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span className={style.impactDetailsDescription}>{" "}{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = showDetails ? style.expanded : "";
  let t6;
  if ($[10] !== t5) {
    t6 = [style.impactDetailsExpandText, t5];
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = t6.join(" ");
  let t8;
  if ($[12] !== showDetails) {
    t8 = () => setShowDetails(!showDetails);
    $[12] = showDetails;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== configuration.missing_evaluation_header || $[15] !== t7 || $[16] !== t8) {
    t9 = <span className={t7} onClick={t8}>{configuration.missing_evaluation_header}</span>;
    $[14] = configuration.missing_evaluation_header;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <td><div className={style.impactContext}>{t4}{t9}</div></td>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2) {
    t11 = <tr className={style.overview} data-cy="donation-impact-list-item-overview">{t2}{t10}</tr>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = showDetails ? "auto" : 0;
  let t13;
  if ($[24] !== configuration.missing_impact_evaluation_text) {
    t13 = <div><PortableText value={configuration.missing_impact_evaluation_text} /></div>;
    $[24] = configuration.missing_impact_evaluation_text;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <tr className={style.details}><td colSpan={Number.MAX_SAFE_INTEGER}><AnimateHeight duration={300} animateOpacity={true} height={t12}>{t13}</AnimateHeight></td></tr>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <tr className={style.spacerRow}><td colSpan={Number.MAX_SAFE_INTEGER} /></tr>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t14) {
    t16 = <>{t11}{t14}{t15}</>;
    $[30] = t11;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};